import { useParams } from 'react-router-dom'
import HotmartAIService from 'src/services/hotmartAI/service'
import { useMutation } from '@tanstack/react-query'
import { PathParams, UseAICreateCompletionProps } from './useAICreateCompletion.types'
import { HOTMART_AI_CONFIG, LANGUAGES } from './useAICreateCompletion.constants'

const useAICreateCompletion = ({ postText, onSuccess }: UseAICreateCompletionProps) => {
  const { lang } = useParams() as PathParams
  const { prompt, max_chars } = HOTMART_AI_CONFIG
  const language = LANGUAGES[lang.toLowerCase()] || 'english'
  const post_text = postText.slice(0, max_chars)
  const mudationPayload = {
    prompt,
    context: {
      post_text,
      language
    }
  }

  return useMutation(() => HotmartAIService.createCompletion(mudationPayload), {
    onSuccess: (response) => {
      const uuid = response?.uuid
      if (uuid) onSuccess(uuid)
    }
  })
}

export default useAICreateCompletion
